<script lang="ts" setup>
import { inject } from 'vue';
import CollapseFieldset from '@/components/CollapseFieldset.vue';

import type { Ref } from 'vue';
import type { IManifest } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
</script>

<template>
  <CollapseFieldset :enable-collapse="false">
    <template #legend>
      Light Intensity Configuration
    </template>

    <div class="flex flex-col">
      <label for="light-intensity" class="text-xs font-bold">Light Intensity <span class="text-normal">({{ Number(manifest.lights[0].lightIntensity).toFixed(2) }})</span></label>

      <div class="flex flex-row">
        <input
          id="light-intensity"
          v-model="manifest.lights[0].lightIntensity"
          type="range"
          min="0"
          max="2"
          step="0.01"
          class="border p-1 text-xs grow"
        >
      </div>
    </div>
  </CollapseFieldset>
</template>
